// extracted by mini-css-extract-plugin
export default {"secondBtn":"modal_secondBtn__RG1UI","copy":"modal_copy__lHtjD"};